export default __webpack_public_path__ + "static/5-ae7283dae65b5235bc092ec65c557340.png";